// Temporary screen registry. Feature screens can be migrated into dedicated
// feature folders independently without coupling them to the admin layout.
export { default as CoursesForm } from "../../../components/sidebar/cources";
export { default as UsersForm } from "../../../components/sidebar/users";
export { default as Sucess } from "../../../components/sidebar/sucess-story";
export { default as Keyword } from "../../../components/sidebar/keyword";
export { default as Home } from "../../../components/sidebar/home";
export { default as CorporateTraning } from "../../../components/CorporateTraning";
export { default as StudentTestimonial } from "../../../components/StudentTestimonial";
export { default as Developers } from "../../../components/Developer";
export { default as Projects } from "../../../components/Project";
export { default as JobWithLocation } from "../../../components/sidebar/jobWithLocation";
export { default as CreateEmployerComponent } from "../../../components/employer";
export { default as BlogForm } from "../../../components/sidebar/blog";
export { default as ArticleAdminPanel } from "../../../components/artical";
export { default as MarketAnalaysis } from "../../../components/sidebar/MarketAnalysis";
export { default as EventsDashboard } from "../../../components/event";
export { default as AudienceForm } from "../../../components/sidebar/audience";
export { default as TrainerForm } from "../../../components/sidebar/trainer";

